// home-component.component.ts

import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';


@Component({
  selector: 'app-home-component',
  templateUrl: './home-component.component.html',
  styleUrls: ['./home-component.component.scss', '../../app.component.scss']
})
export class HomeComponentComponent {

  activeTab: string = 'alerts';

  constructor(private router: Router) { }

  ngOnInit(): void {
    // Listen to route changes
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updateActiveTab();
    });
  }

  
  updateActiveTab(): void {
    const currentUrl = this.router.url;
    if (currentUrl.includes('home/stores')) {
      this.activeTab = 'stores';
    } else if (currentUrl.includes('home/warehouses')) {
      this.activeTab = 'warehouses';
    } else if (currentUrl.includes('home/alerts-notify')){
      this.activeTab = 'alerts';
    }
  }

  setActiveTab(tab: string): void {
    this.activeTab = tab;
    // Update route based on active tab
    switch (tab) {
      case 'alerts':
        this.router.navigate(['home/alerts-notify']);
        break;
      case 'stores':
        this.router.navigate(['home/stores']);
        break;
      case 'warehouse':
        this.router.navigate(['home/warehouses']);
        break;
      default:
        break;
    }
  }

}
